import React from 'react';
import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import { Col, Row } from '@digitools/honest-react';
import { DentalTileContainer, DentalTileHeading, DentalTileText, DentalTileTitle, StyledDentalTile, StyledIcon, } from 'src/packages/dental/styles/DentalStyles';
export var dentalTileTypeEnum;
(function (dentalTileTypeEnum) {
    dentalTileTypeEnum["LINK"] = "LINK";
    dentalTileTypeEnum["TAB"] = "TAB";
    dentalTileTypeEnum["BUTTON"] = "BUTTON";
})(dentalTileTypeEnum || (dentalTileTypeEnum = {}));
export const DentalTileInformation = ({ props }) => {
    const { activeTab } = useDentalDataContext();
    const active = !!(props.component && props.component == activeTab);
    const iconColor = props.disabled
        ? 'gray'
        : activeTab == props.component
            ? 'primary'
            : 'secondaryLight';
    return (<>
      <DentalTileHeading>
        {props.imageName && (<StyledIcon style={{ float: 'left' }} name={props.imageName} size={'large'} id={`${props.imageName}Icon`} color={iconColor}/>)}
        {props.image && props.image}
        {props.hasOutArrow && (<StyledIcon style={{ float: 'right' }} className={'mt-0'} name={'out-arrow'} size={'medium'} id={`${props.imageName}OutArrow`} color={iconColor}/>)}
        <DentalTileTitle disabled={props.disabled} active={active}>
          {props.title}
        </DentalTileTitle>
      </DentalTileHeading>
      {props.text && <DentalTileText id={`${props.title}Information`}>{props.text}</DentalTileText>}
    </>);
};
export const DentalButtonContent = ({ props }) => {
    return (<DentalTileContainer data-public={true}>
      <StyledDentalTile as={'button'} ref={props.buttonRef} id={props.title.replace(/[^a-zA-Z0-9]/g, '-') + '-button'} {...(props.ariaLabel ? { 'aria-label': props.ariaLabel } : {})} {...(props.disabled ? { cursor: 'not allowed', 'aria-disabled': 'true' } : {})} onClick={e => {
            if (props.action) {
                props.action();
            }
        }}>
        <DentalTileInformation props={props}/>
      </StyledDentalTile>
    </DentalTileContainer>);
};
export const DentalLinkContent = ({ props }) => {
    return (<DentalTileContainer data-public={true}>
      <StyledDentalTile as={'a'} style={{ textDecoration: 'none' }} {...{ href: props.href }} rel={'noreferrer'} {...{ target: '_blank' }} aria-labelledby={`link to ${props.title}`} {...(props.ariaLabel ? { 'aria-label': props.ariaLabel } : {})} {...(props.disabled ? { cursor: 'not allowed', 'aria-disabled': 'true' } : {})} onClick={e => {
            if (props.action) {
                props.action();
            }
        }}>
        <DentalTileInformation props={props}/>
      </StyledDentalTile>
    </DentalTileContainer>);
};
export const DentalTile = ({ image, imageName, component, text, hasOutArrow, isLeftCentered, eventAction, type, ariaLabel, disabled, action, href, title, isInline, event, buttonRef, }) => {
    const props = {
        image: image,
        imageName: imageName,
        event: event,
        component: component,
        isInline: isInline,
        title: title,
        text: text,
        hasOutArrow: hasOutArrow,
        action: action,
        isLeftCentered: isLeftCentered,
        href: href,
        eventAction: eventAction,
        disabled: disabled,
        ariaLabel: ariaLabel,
        type: type,
        buttonRef: buttonRef,
    };
    return isInline ? (<Col>
      {type === dentalTileTypeEnum.LINK ? <DentalLinkContent props={props}/> : <DentalButtonContent props={props}/>}
    </Col>) : (<Row>
      <Col>
        {type === dentalTileTypeEnum.LINK ? <DentalLinkContent props={props}/> : <DentalButtonContent props={props}/>}
      </Col>
    </Row>);
};
export default DentalTile;
